import api from '@/api';

const state = {
  members: [],
};

const getters = {
  getMemberFormattedNameById: state => (id) => {
    const member = state.members.find(x => x.id === parseInt(id, 10));
    return member ? `${member.firstName}, ${member.lastName}` : '';
  },
};

const actions = {
  async getList({ commit }) {
    if (state.members.length > 0) {
      return;
    }
    const response = await api.get('Members');
    commit('members', response.data.members);
  },
};

const mutations = {
  members(state, payload) {
    state.members = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
